import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ManualInvestComponent} from './manual-invest.component';
import {AuthGuard, BorrowerObstructGuard} from '../../auth.guard';
import {SelectedManualInvestmentsGuard} from './selected-manual-investments.guard';
import {ManualInvestListedLoansResolver} from './manual-invest-listed-loans.resolver';
import {PortfolioCreationDataResolver} from '../resolvers/portfolio-creation-data-resolver';
import {ManualinvestsummaryComponent} from '../manualinvestsummary/manualinvestsummary.component';
import {PortfolioPreferenceResolver} from '../portfolio-preference/portfolio-preference.resolver';
import {PortfolioPreferenceComponent} from '../portfolio-preference/portfolio-preference.component';

const routes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        component: ManualInvestComponent,
        resolve: {
            investments: ManualInvestListedLoansResolver,
            portfolioCreationData: PortfolioCreationDataResolver
        },
        canActivate: [AuthGuard, BorrowerObstructGuard],
    }, {
        pathMatch: 'full',
        path: 'portfolio-preference',
        component: PortfolioPreferenceComponent,
        canActivate: [AuthGuard, BorrowerObstructGuard, SelectedManualInvestmentsGuard],
        resolve: {
            investDetail: PortfolioPreferenceResolver,
            portfolioCreationData: PortfolioCreationDataResolver
        }
    }, {
        pathMatch: 'full',
        path: 'portfolio-summary',
        component: ManualinvestsummaryComponent,
        canActivate: [AuthGuard, BorrowerObstructGuard, SelectedManualInvestmentsGuard],
        resolve: {
            portfolioCreationData: PortfolioCreationDataResolver
        }
    }];

@NgModule({
    exports: [RouterModule],
    imports: [RouterModule.forChild(routes)],
    providers: [AuthGuard, BorrowerObstructGuard]
})
export class ManualInvestRoutingModule {
}